import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../common/Reveal';
import { Hero, Problem, Difference, HowItWorks, Features, Audiences, OperatingModel, PartnerBand } from '../SafeHand/Sections';
import { useLang, usePageTitle } from '../../i18n/LanguageContext';

function StudioTeaser() {
  const { t } = useLang();
  const s = t.studio;
  return (
    <section className="section">
      <div className="container studio">
        <Reveal className="studio__copy">
          <p className="eyebrow">{s.eyebrow}</p>
          <h2 className="section-title">{s.title}</h2>
          <p className="section-lead">{s.lead}</p>
          <div className="studio__ctas">
            <Link to="/services" className="btn btn--outline">
              {s.cta} <i className="fa-solid fa-arrow-right flip-rtl" aria-hidden="true" />
            </Link>
            <Link to="/portfolio" className="text-link">
              {t.nav.work} <i className="fa-solid fa-arrow-right flip-rtl" aria-hidden="true" />
            </Link>
          </div>
        </Reveal>
        <div className="stats">
          {s.stats.map((st, i) => (
            <Reveal key={st.label} delay={i * 80} className="stat">
              <strong dir="ltr">{st.value}</strong>
              <span>{st.label}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  usePageTitle('');
  return (
    <>
      <Hero />
      <Problem />
      <Difference />
      <HowItWorks />
      <Features />
      <Audiences />
      <OperatingModel />
      <StudioTeaser />
      <PartnerBand />
    </>
  );
}
